import { UI_DATE_FORMAT_WITH_TIME_24 } from 'globalconfig/constants/static';
import moment from 'moment';
import React, { lazy, useState } from 'react';
import ViewForm from './Form';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const ViewDCA = ({
  i18n,
  changeRequest,
  apiStatus,
  dcaList,
  request,
  information,
  Styled,
  callback,
  basicRequest,
  commonProps,
}) => {
  const [pagination, setPagination] = React.useState(false);
  const [filterValue, setFilterValue] = useState({});

  const generateRows = () => {
    const list = dcaList?.list;
    return list.map((e) => {
      return {
        ...e,
        fromDate: e?.startTime ? moment(e?.startTime).format(UI_DATE_FORMAT_WITH_TIME_24) : '-',
        toDate: e?.endTime ? moment(e?.endTime).format(UI_DATE_FORMAT_WITH_TIME_24) : '-',
      };
    });
  };

  const tableData = (fields) => {
    setFilterValue(fields);
  };

  return (
    <Styled.Wrapper>
      <Styled.TopWrapper>
        <ViewForm
          hasApiStatus={apiStatus}
          callback={callback}
          request={request}
          changeRequest={changeRequest}
          setPagination={setPagination}
          tableData={(fields) => tableData(fields)}
          commonProps={commonProps}
          i18n={i18n}
          basicRequest={basicRequest}
        />
      </Styled.TopWrapper>
      <Styled.TableWrapper>
        <Table
          type="server"
          defaultSortBy={{}}
          title=""
          columns={[...columns]}
          changeRequest={(e) => {
            changeRequest({ ...e, ...filterValue });
          }}
          apiStatus={apiStatus}
          baseRequest={request}
          data={generateRows()}
          emptyMessage={information}
          totalRecords={dcaList?.totalRecords || 0}
          itemsPerPage={15}
          i18n={i18n}
          pageinationReset={pagination}
          actions={[]}
          pagenationClicked={(e) => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            setPagination(!e);
          }}
        />
      </Styled.TableWrapper>
    </Styled.Wrapper>
  );
};

export default ViewDCA;
